import {EventEditor} from "./EventEditor";
import {HOVER_COLOR} from "./ProcessNodeEditor";

export class EndNodeEditor extends EventEditor {
	constructor(parent, node, coords) {
		super(parent, node, coords);
	}

	get lineWidth() {
		return 4;
	}

	get bg() {
		return this.hovered ? HOVER_COLOR : "#ffeded";
	}
}